import { FETCH_SIZES, FETCH_COUNTRIES, FETCH_METADATA } from './types';
import DashBoard from '../apis/DashBoard';
import globalApi from '../apis/swagup/global';
import { okAndLog, errorAndLog } from '../helpers/utils';
import apiPaths from '../helpers/apiPaths';
import log from '../logger';

export const fetchSizes = () => async dispatch => {
  log.debug('fetchSizes Action - Entering');
  try {
    const sizesAPI = await DashBoard.get(apiPaths.sizes);
    if (sizesAPI.status === 200) {
      const sizes = sizesAPI.data.results;
      dispatch({
        type: FETCH_SIZES,
        payload: sizes
      });
      return okAndLog('fetchSizes', sizesAPI.status, sizes);
    }
    return errorAndLog('fetchSizes', sizesAPI.status, sizesAPI.data);
  } catch (e) {
    return errorAndLog('fetchSizes', e.status, e.data);
  }
};

export const getOnboardingOnlySizes = async () => {
  log.debug('fetchSizes Action - Entering');
  try {
    // fixed sizes are required in order to force onboarding clients to only choose on this sample packs friendly sizes
    const fixedSizes = [
      { id: 1, name: 'XS', category: 'Apparel', modified_on: '2019-12-11T14:30:21.916348Z', sort_order: 2 },
      { id: 2, name: 'S', category: 'Apparel', modified_on: '2019-12-11T14:30:21.921418Z', sort_order: 3 },
      { id: 3, name: 'M', category: 'Apparel', modified_on: '2019-12-11T14:30:21.924795Z', sort_order: 4 },
      { id: 4, name: 'L', category: 'Apparel', modified_on: '2019-12-11T14:30:21.927945Z', sort_order: 5 },
      { id: 5, name: 'XL', category: 'Apparel', modified_on: '2019-12-11T14:30:21.931354Z', sort_order: 6 },
      { id: 6, name: '2XL', category: 'Apparel', modified_on: '2019-12-11T14:30:21.934788Z', sort_order: 7 },
      { id: 7, name: '3XL', category: 'Apparel', modified_on: '2019-12-11T14:30:21.938177Z', sort_order: 8 }
    ];
    if (fixedSizes) {
      return okAndLog('fetchSizes', 200, fixedSizes);
    }
    return errorAndLog('fetchSizes', 400, fixedSizes);
  } catch (e) {
    return errorAndLog('fetchSizes', e.status, e.data);
  }
};

export const loadCountries = (active = true) => async dispatch =>
  DashBoard.get(apiPaths.countries, { params: { active }, validateStatus: status => status === 200 })
    .then(({ status, data }) => {
      dispatch({
        type: FETCH_COUNTRIES,
        payload: data.results
      });
      return okAndLog('loadCountries', status, data.results);
    })
    .catch(({ response }) => errorAndLog('loadCountries', response?.status, response?.data));

export const clearbitEmailValidation = async email => {
  log.debug('clearbitEmailValidation Action - Entering');
  try {
    const apiCall = await DashBoard.post(apiPaths.samplePacksEmails, { email });
    if (apiCall.status === 201) {
      return okAndLog('clearbitEmailValidation', apiCall.status, apiCall.data);
    }
    return errorAndLog('clearbitEmailValidation', apiCall.status, apiCall.data);
  } catch (e) {
    return errorAndLog('clearbitEmailValidation', e.status, e.data);
  }
};

export const loadMetadata = () => async dispatch =>
  globalApi
    .fetchMetadata()
    .then(results => {
      const metadata = {};
      results.forEach(r => {
        metadata[r.field] = r.value;
      });

      dispatch({
        type: FETCH_METADATA,
        payload: metadata
      });
      return okAndLog('loadMetadata', 200, results);
    })
    .catch(({ response }) => errorAndLog('loadMetadata', response?.status, response?.data));
